import classnames from 'classnames';
import React from 'react';
import styles from './proposalResponseTokenMessage.module.scss';

interface ProposalTokenMessageProps {
  text: string;
  title?: string;
}

const ProposalResponseTokenMessage = ({
  text,
  title,
}: ProposalTokenMessageProps) => {
  return (
    <div
      className={classnames(
        'd-flex align-items-center justify-content-center flex-column h-100',
        styles.root
      )}
    >
      {title ? (
        <h2 className="d-block text-primary-dark font-weight-bold mb-4">
          {title}
        </h2>
      ) : null}
      <p className="text-center text-primary-dark py-0 px-5 m-0 text-primary.dark">
        {text}
      </p>
    </div>
  );
};

export default ProposalResponseTokenMessage;
